import { ChangeDetectionStrategy, Component, input } from '@angular/core'
import { JobSpec, JobSpecDomain } from '../job-spec'

@Component({
  selector: 'app-job-spec-view',
  templateUrl: './job-spec-view.component.html',
  styleUrls: ['./job-spec-view.component.scss'],
})
export class JobSpecViewComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public readonly spec = input.required<JobSpec>()
  protected readonly JobSpecDomain = JobSpecDomain

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/
}
